export enum StepProcessedEnum {
  NOT_EXECUTED = "NOT_EXECUTED",
  IN_PROGRESS = "IN_PROGRESS",
  COMPLETED = "COMPLETED"
}

export enum ServiceRequestStepEnum {
  SERVICE_REQUEST_CREATED = "SERVICE_REQUEST_CREATED",
  SERVICE_REQUEST_COMMERCIAL_ANALYSIS = "SERVICE_REQUEST_COMMERCIAL_ANALYSIS",
  BUDGET_REGULATION = "BUDGET_REGULATION",
  WAITING_APPROVAL_FOR_EXECUTION = "WAITING_APPROVAL_FOR_EXECUTION",
  BUDGET_APPROVED = "BUDGET_APPROVED",
  MAINTENANCE_IN_EXECUTION = "MAINTENANCE_IN_EXECUTION",
  VEHICLE_DIAGNOSTICS_IN_PROGRESS = "VEHICLE_DIAGNOSTICS_IN_PROGRESS",
  MAINTENANCE_FINISHED = "MAINTENANCE_FINISHED",
  MAINTENANCE_CANCELED = "MAINTENANCE_CANCELED",
  MAINTENANCE_REPROVED = "MAINTENANCE_REPROVED"
}
